import React from 'react';
import styled, { css } from 'styled-components';
import { buttonWithIconMargin } from "../../styles/index.js";
var Wrapper = styled.span.withConfig({
  displayName: "IconWrapper__Wrapper",
  componentId: "sc-16usrgb-0"
})(["display:flex;", ""], function (_ref) {
  var buttonSize = _ref.buttonSize,
    position = _ref.position;
  return css(["", " ", ""], position === 'leading' && css(["margin-inline-end:", ";"], buttonWithIconMargin[buttonSize]), position === 'trailing' && css(["margin-inline-start:", ";"], buttonWithIconMargin[buttonSize]));
});
export var IconWrapper = function IconWrapper(_ref2) {
  var position = _ref2.position,
    buttonSize = _ref2.buttonSize,
    icon = _ref2.icon,
    iconSize = _ref2.iconSize;
  var Icon = icon;
  return /*#__PURE__*/React.createElement(Wrapper, {
    position: position,
    buttonSize: buttonSize,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Icon, {
    iconSize: iconSize
  }));
};